import { Card, CardContent, Typography, Stack, Box } from "@mui/material";
import PeopleIcon from '@mui/icons-material/People';
import ProgressIcon from '@mui/icons-material/SignalCellularAlt';
import CheckIcon from '@mui/icons-material/TaskAlt';
import StarsIcon from '@mui/icons-material/AutoAwesomeSharp';
import SchoolIcon from '@mui/icons-material/School';
import WinIcon from '@mui/icons-material/EmojiEvents';
import PaidIcon from '@mui/icons-material/Paid';
import PigIcon from '@mui/icons-material/Savings';
import HandshakeIcon from '@mui/icons-material/Handshake';
import GaugueIcon from '@mui/icons-material/Speed';
import { Toll } from "@mui/icons-material";

export default function Kpi({title, unit, caption, icon, sx, color}){

    const icons = {
        people: <PeopleIcon fontSize='large' style={{color: 'white', opacity: 0.7}} />,
        progress: <ProgressIcon fontSize='large' style={{color: 'white', opacity: 0.7}} />,
        check: <CheckIcon fontSize='large' style={{color: 'white', opacity: 0.7}} />,
        stars: <StarsIcon fontSize='large' style={{color: 'white', opacity: 0.7}} />,
        school: <SchoolIcon fontSize='large' style={{color: 'white', opacity: 0.7}} />,
        win: <WinIcon fontSize='large' style={{color: 'white', opacity: 0.7}} />,
        paid: <PaidIcon fontSize='large' style={{color: 'white', opacity: 0.7}} />,
        pig: <PigIcon fontSize='large' style={{color: 'white', opacity: 0.7}} />,
        handshake: <HandshakeIcon fontSize='large' style={{color: 'white', opacity: 0.7}} />,
        gaugue: <GaugueIcon fontSize='large' style={{color: 'white', opacity: 0.7}} />,
        toll: <Toll fontSize='large' style={{color: 'white', opacity: 0.7}} />
    };

    const clr = color || '#6495ED';

    let s = sx || {};
    s.minWidth = sx?.minWidth || 220;
    s.backgroundColor = clr;
    s.boxShadow = 'none';
    s.pt = sx?.pt || 1;
    s.pb = sx?.pb || 1;

    return <Card sx={s}>

        <CardContent>

            <Stack direction='row' alignItems='center' spacing={2}>

                {icons[icon]}

                <Box>

                    <Typography variant="h2" sx={{mt: 1, color: 'white', opacity: 1}}>
                        {title} {unit ? <small>{unit}</small> : ''}
                    </Typography>

                    <Typography  sx={{color: 'white', opacity: 0.7}}>
                        {caption}
                    </Typography>
                    
                </Box>
                
            </Stack>

        </CardContent>
        
    </Card>
}
